export default __webpack_public_path__ + "static/media/2ae0d0d7ce3684c19b1c2b875fa0115e.svg";